import { useEffect } from 'react';

/**
 * `<link rel="canonical">` etiketini rota değişiminde günceller.
 *
 * SPA'da `index.html` tek olduğu için statik bir canonical BÜTÜN sayfaları
 * ana sayfanın kopyası ilan ederdi — bu, hiç canonical olmamasından kötü.
 * Etiket bu yüzden statik dosyada yok; JavaScript'i çalıştıran tarayıcılar
 * (Google dahil) render edilmiş hâli okur, çalıştırmayanlar etiketsiz
 * sayfayı — yani bugünkü davranışı — görür.
 *
 * Amaç kopya adreslerin (`?utm=...`, sondaki eğik çizgi, büyük harf) tek bir
 * adrese toplanması; `activePath` `normalizePath`'ten geçmiş geldiği için bu
 * varyantların hepsi aynı canonical'i üretir.
 *
 * Panel ve giriş ekranında etiket KALDIRILIR: robots.txt o yolları zaten
 * taramadan çıkarıyor, kalmış bir canonical son gezilen tanıtım sayfasını
 * gösterirdi.
 */
export function useCanonical(activePath: string, isPublic: boolean): void {
  useEffect(() => {
    const existing = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (!isPublic) {
      existing?.remove();
      return;
    }

    const link = existing ?? document.createElement('link');
    link.rel = 'canonical';
    link.href = `${window.location.origin}${activePath}`;
    if (existing === null) document.head.appendChild(link);
  }, [activePath, isPublic]);
}
